import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import API_BASE from '../api';

export default function MemberCard() {
  const { id } = useParams();
  const [member, setMember] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    axios.get(API_BASE + '/members/' + id)
      .then(r => setMember(r.data))
      .catch(() => setError('חבר לא נמצא'));
  }, [id]);

  if (error) return (
    <div style={{minHeight:'100vh', background:'#060d1e', display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', padding:24, direction:'rtl'}}>
      <div style={{color:'#ff6b6b', fontSize:'1.2rem', marginBottom:20}}>{error}</div>
      <Link to="/" className="btn btn-gold">חזור לדף הבית</Link>
    </div>
  );

  if (!member) return (
    <div style={{minHeight:'100vh', background:'#060d1e', display:'flex', alignItems:'center', justifyContent:'center'}}>
      <div style={{color:'#d4af37', fontSize:'1.1rem'}}>טוען...</div>
    </div>
  );

  const memberNum = member.member_number
    ? String(member.member_number).padStart(member.member_number > 99 ? 3 : 2, '0')
    : member.id;
  const waMessage = encodeURIComponent(`שלום! הצטרפתי לליגת הכוכבים של יוסטאר (מספר חבר ${memberNum}) ואני רוצה לשלוח תמונה של הילד שלי להכנת קלף הכוכבים 🌟`);
  const waLink = `https://wa.me/9720546318704?text=${waMessage}`;

  return (
    <div style={{minHeight:'100vh', background:'linear-gradient(180deg,#060d1e 0%,#0a1a3e 100%)', padding:'40px 20px', direction:'rtl', fontFamily:"'Heebo', sans-serif"}}>
      <div style={{maxWidth:620, margin:'0 auto'}}>

        {/* כותרת ראשית */}
        <div style={{textAlign:'center', marginBottom:36}}>
          <img src="/club-logo.png" alt="ליגת הכוכבים של יוסטאר"
            style={{width:'min(480px, 95%)', marginBottom:24, filter:'drop-shadow(0 4px 32px rgba(212,175,55,0.5))'}} />
          <div style={{fontSize:'2.4rem', marginBottom:10}}>🎉</div>
          <h1 style={{color:'#d4af37', fontWeight:900, fontSize:'clamp(1.5rem,4vw,2rem)', margin:'0 0 12px', lineHeight:1.3}}>
            ברוכים הבאים לליגת הכוכבים של יוסטאר!
          </h1>
          <p style={{color:'#c0cce6', fontSize:'1rem', lineHeight:1.7, margin:0}}>
            איזה כיף שהצטרפתם למשפחה.
          </p>
        </div>

        {/* כרטיס מספר חבר */}
        <div style={{background:'linear-gradient(135deg,rgba(212,175,55,0.12),rgba(212,175,55,0.06))', border:'2px solid rgba(212,175,55,0.4)', borderRadius:16, padding:'20px 24px', textAlign:'center', marginBottom:28}}>
          <div style={{color:'#8a9aba', fontSize:'0.85rem', marginBottom:6}}>מספר חבר המועדון שלכם</div>
          <div style={{color:'#d4af37', fontWeight:900, fontSize:'2.2rem', letterSpacing:2}}>#{memberNum}</div>
          <div style={{color:'#fff', fontWeight:700, fontSize:'1rem', marginTop:4}}>{member.first_name}</div>
          {member.child_name && <div style={{color:'#8a9aba', fontSize:'0.88rem', marginTop:4}}>שחקן/ית: {member.child_name}</div>}
        </div>

        {/* מה קורה עכשיו */}
        <div style={{background:'rgba(255,255,255,0.03)', border:'1px solid #1a2a4a', borderRadius:16, padding:'24px', marginBottom:28}}>
          <h2 style={{color:'#fff', fontWeight:800, fontSize:'1.1rem', margin:'0 0 14px'}}>⚽ מה קורה עכשיו?</h2>
          <p style={{color:'#c0cce6', fontSize:'0.92rem', lineHeight:1.85, margin:0}}>
            ההרשמה הושלמה ומספר החבר שלכם מוכן 🎉
            כדי שנעצב לשחקן/ית את <strong style={{color:'#d4af37'}}>קלף הכוכבים האישי במתנה</strong>, נתאם איתכם בוואטסאפ תמונה מהמגרש, כתובת למשלוח ודמי משלוח (20 ₪ בביט או פייבוקס).
            בוואטסאפ תוכלו גם להתייעץ ולהזמין את מוצרי הווידאו שלנו — קליפ ביצועים, קליפ בר/בת מצווה ועריכת משחקים.
          </p>
        </div>

        {/* זירוז — אופציונלי, ביוזמת ההורה */}
        <div style={{background:'linear-gradient(135deg,rgba(37,211,102,0.07),rgba(37,211,102,0.03))', border:'1px solid rgba(37,211,102,0.25)', borderRadius:16, padding:'24px', marginBottom:32, textAlign:'center'}}>
          <div style={{color:'#fff', fontWeight:800, fontSize:'1rem', marginBottom:10}}>
            🚀 רוצים לזרז ולקבל את הקלף מהר יותר?
          </div>
          <p style={{color:'#c0cce6', fontSize:'0.88rem', lineHeight:1.75, marginBottom:20}}>
            שלחו לנו עכשיו הודעת וואטסאפ עם תמונה של השחקן/ית מהמגרש — ונתחיל לעצב מיד את הקלף.
          </p>
          <a href={waLink} target="_blank" rel="noopener noreferrer" style={{
            display:'inline-flex', alignItems:'center', gap:10,
            background:'#25d366', borderRadius:30, padding:'13px 28px',
            color:'#fff', textDecoration:'none', fontWeight:800, fontSize:'1rem',
            boxShadow:'0 4px 20px rgba(37,211,102,0.4)',
          }}>
            <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/><path d="M12 0C5.373 0 0 5.373 0 12c0 2.123.554 4.118 1.528 5.847L.057 23.882l6.197-1.448A11.934 11.934 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.894a9.876 9.876 0 0 1-5.031-1.378l-.361-.214-3.741.981.998-3.648-.235-.374A9.867 9.867 0 0 1 2.106 12C2.106 6.535 6.535 2.106 12 2.106c5.466 0 9.894 4.429 9.894 9.894 0 5.466-4.428 9.894-9.894 9.894z"/></svg>
            שליחת תמונה בוואטסאפ ליוסטאר
          </a>
        </div>

        {/* קישור לדף הבית */}
        <div style={{textAlign:'center'}}>
          <Link to="/" style={{color:'#5a7aa0', fontSize:'0.88rem', textDecoration:'none'}}>
            ← חזרה לדף הבית של המועדון
          </Link>
        </div>

      </div>
    </div>
  );
}
